// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"Q3-z","dimensionLabel":"R3-z","styleChooserControlWrapper":"S3-z","styleChooserControl":"T3-z","disabled":"U3-z","giftCard":"V3-z","styleChooserText":"W3-z"};